/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as semver from 'semver';

/**
 * Sort direction for sortVersions.
 */
type Direction = 'asc' | 'desc';

/**
 * Sorts an array of semver strings.
 * @param {string[]} versions An array of semver strings.
 * @param {Direction} direction The direction to sort the array.
 * @returns {string[]} A sorted array of semver strings.
 */
export const sortVersions = (versions: Array<string>, direction: Direction): Array<string> => {
  if (!Array.isArray(versions)) {
    throw new Error('It is not an array');
  }

  if (direction !== 'asc' && direction !== 'desc') {
    throw new Error('Invalid direction');
  }

  const compare = direction === 'asc' ? semver.compare : semver.rcompare;

  return versions.sort((v1, v2) => {
    return compare(v1, v2);
  });
};
